import React, { useEffect, useState } from 'react';
import DynamicFlowManage from '../../../pages/admin/pages/DynamicFlowManage';
import { Drawer } from 'antd';
const { REACT_APP_BASE_API_URI } = process.env;

const Workflow = (props) => {
  const [frameSource, setFrameSource] = useState(`${REACT_APP_BASE_API_URI}workflows`);
  const [showDrawer, setShowDrawer] = useState(false);  
  useEffect(() => {
    if (props.wfId) {
      const singleFlowUrl = `${process.env.REACT_APP_BASE_API_URI}workflow/${props.wfId}/${props.wfCatId || 0}`;
      setFrameSource(singleFlowUrl);
    }
  }, [props]);

  return (
    <>
      {/* <Button onClick={() => setShowDrawer(true)}>Component Based Flow Create</Button> */}

      <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
        <iframe
          //src={`${REACT_APP_BASE_API_URI}workflows`}
          src={frameSource}
          title="workflows"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',  // Remove border if you want a seamless look
          }}
          allowFullScreen
        />
      </div>

      {showDrawer && (
        <Drawer
          title="Component Test Flow"
          placement="right"
          className="custom-drawers cus-drawer-sm"
          onClose={() => setShowDrawer(false)}
          open={showDrawer}
          width={600}
        >
          <DynamicFlowManage />
        </Drawer>
      )}
    </>
  );
};

export default Workflow;
